import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class TrainerEndpointsService {
  readonly #service = inject(ServicesService);

  session() {
    return this.#service.thor('trainer/session');
  }

  response() {
    return this.#service.thor('trainer/response');
  }

  finish(sessionId: string) {
    return this.#service.thor(`trainer/session/${sessionId}/finish`);
  }
}
